import { render } from "./AlertPreviewComponent.vue?vue&type=template&id=5fc95b79&scoped=true"
import script from "./AlertPreviewComponent.vue?vue&type=script&lang=js"
export * from "./AlertPreviewComponent.vue?vue&type=script&lang=js"

import "./AlertPreviewComponent.vue?vue&type=style&index=0&id=5fc95b79&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc95b79"]])

export default __exports__